const COMPONENT_NAME = "StockStatus";
const IN_STOCK_KEY = "instock";
const LOW_STOCK_KEY = "lowstock";
const OUT_OF_STOCK_KEY = "outofstock";
const ITEM_NOT_SOLD_KEY = "itemnotsold";
const SHIPS_TO_WAREHOUSE_KEY = "shipstowarehouse";
const FOR_PICKUP_KEY = "forpickup";
const AT_WAREHOUSE_KEY = "atwarehouse";
const READY_KEY = "ready";
const WITHIN_KEY = "within";
const FOUR_HOURS_KEY = "fourhours";
const TOMORROW_KEY = "tomorrow";
const BUY_IN_WAREHOUSE_KEY = "buyinwarehouse";
const OPTIONS_COLORS_AND_SIZES_MAY_VARY_KEY = "optionscolorsandsizesmayvary";
const WAREHOUSE_UNAVAILABLE_KEY = "warehouseunavailable";
export {
  AT_WAREHOUSE_KEY,
  BUY_IN_WAREHOUSE_KEY,
  COMPONENT_NAME,
  FOR_PICKUP_KEY,
  FOUR_HOURS_KEY,
  IN_STOCK_KEY,
  ITEM_NOT_SOLD_KEY,
  LOW_STOCK_KEY,
  OPTIONS_COLORS_AND_SIZES_MAY_VARY_KEY,
  OUT_OF_STOCK_KEY,
  READY_KEY,
  SHIPS_TO_WAREHOUSE_KEY,
  TOMORROW_KEY,
  WAREHOUSE_UNAVAILABLE_KEY,
  WITHIN_KEY
};
